// extracted by mini-css-extract-plugin
export var careersBtn = "career-block-module--careersBtn--nKSoM";
export var careersSection = "career-block-module--careersSection--Q17PP";
export var careersSectionDescription = "career-block-module--careersSectionDescription--kSKhp";
export var careersSectionLink = "career-block-module--careersSectionLink--TtV3R";
export var careersSectionWrapper = "career-block-module--careersSectionWrapper--wfviF";